import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import es from 'date-fns/locale/es';
import { getUserLoggedLS } from '../../util/LocalStorageUtils';
import { fetchGuardiasProfesor } from './Guardias-Api';
import { startOfWeek, addDays } from 'date-fns';
import { Grid, Paper, Typography, Chip } from '@mui/material';

const GuardList = ({ profesorId, currentDate, serial }) => {
    const [guards, setGuards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchInitialData();
    }, [currentDate]);

    useEffect(() => {
        fetchInitialData();
    }, [serial]);

    const alTerminarCargaGuardias = (data) => {
        setGuards(data);
        setLoading(false);
    }

    const fetchInitialData = async () => {
        setLoading(true);
        setError(null);
        try {
            const startDate = startOfWeek(currentDate, { locale: es, weekStartsOn: 1 });
            const endDate = addDays(startDate, 4); // Suponiendo 5 días laborales
            if (!profesorId) {
                let userLogged = getUserLoggedLS();
                profesorId = userLogged.id;
            }
            fetchGuardiasProfesor(profesorId, format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'), alTerminarCargaGuardias);
        } catch (err) {
            setError('Error al cargar los datos de ausencias y guardias');
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Cargando tus guardias...</div>;
    }

    if (error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    if (guards.length === 0) {
        return <div className="alert alert-info">No tienes ninguna guardia asignada actualmente.</div>;
    }

    return (
        <div>
            <Typography variant="h6" gutterBottom>
                Tus Guardias Asignadas esta semana 
            </Typography>
            <Grid container spacing={2}>
                {guards.map(guardia => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={guardia.id}>
                        <Paper elevation={3} style={{ padding: 16 }}>
                            <Typography variant="subtitle2" gutterBottom>
                                <strong>Fecha:</strong> {format(new Date(guardia.fecha), 'dd/MM/yyyy', { locale: es })}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <strong>Franja:</strong> {guardia.franja}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <strong>Profesor Ausente:</strong> {guardia.profesor?.nombre}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <strong>Aula:</strong> {guardia.celdaHoraria?.aula?.codigo} - {guardia.celdaHoraria?.grupos}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                <strong>Aula destino:</strong> {guardia.aulaDestino?.codigo}
                            </Typography>
                            {guardia.firmada ? (
                                <Chip label="Firmada" color="success" size="small" />
                            ) : (
                                <Chip label="No firmada" color="error" size="small" />
                            )}
                            {guardia.observaciones && (
                                <Typography variant="caption" display="block" style={{ marginTop: 8 }}>
                                    <strong>Observaciones:</strong> <small>{guardia.observaciones}</small>
                                </Typography>
                            )}
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default GuardList;